import { createAsyncThunk } from "@reduxjs/toolkit";
import { emptyTrash, getTrashFilesFolders } from "store/services/trash";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import { openToast } from "store/slices/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetTrashFilesFoldersAction = createAsyncThunk(
  "trash/getTrashFilesFolders",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getTrashFilesFolders(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const EmptyTrashAction = createAsyncThunk(
  "trash/emptyTrash",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, ...rest } = payload;
      const response = await emptyTrash(rest);
      if (response.status === 1) {
        dispatch(closeCenterModal());
        onSuccess && onSuccess();
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
